import React, { Component } from 'react';
import { Button, Col } from 'reactstrap';
import '../Login.css';


export class HomeButtonCat extends Component {

    handleClick = (e) => {
        if (!this.props.off) {
            this.props.history.push(this.props.path);
        }

    }

    clickFunction = (e) => {
        if (!this.props.clicked) {
            return this.handleClick(e);
        }
        else {
            return this.props.clicked(this.props.id, this.props.name);
        }
    }

    render() {
        return (
            <Col id="wrapper" className={this.props.classes} style={{ padding: '0px', paddingTop: '15px' }}>
                <Button id={this.props.buttonId} style={{ padding: '0px', height: '22vh', width: '22vh', backgroundColor: this.props.buttonBackground ? this.props.buttonBackground : 'transparent', border: 'none', borderRadius: '25px' }} onClick={this.clickFunction}>
                    <img className={this.props.imgClasses} style={{ height: '100%', width: '100%' }} src={this.props.image} alt={this.props.name}></img>
                    {this.props.needsText ? <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>{this.props.name}</div> : null}
                </Button>
            </Col>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Catalogo/HomeButtonCat.js